"use client";
import { ark } from "../factory.js";
import { useCheckboxContext } from "./use-checkbox-context.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/checkbox/checkbox-label.tsx
var CheckboxLabel = forwardRef((props, ref) => {
	const mergedProps = mergeProps(useCheckboxContext().getLabelProps(), props);
	return /* @__PURE__ */ jsx(ark.span, {
		...mergedProps,
		ref
	});
});
CheckboxLabel.displayName = "CheckboxLabel";
//#endregion
export { CheckboxLabel };
